import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';

import Select from '../../common/inputs/Select';
import useStyles from './styles';

const QuestionBarChart = ({ data }) => {
  const [selectedQuestion, setSelectedQuestion] = useState('0');
  const { t } = useTranslation(['translation']);
  const classes = useStyles();

  const answers = get(data[selectedQuestion], 'answers', [])
    .map((a) => ({ name: a.name, value: a.count }));

  const total = answers.reduce((acc, cv) => acc + cv.value, 0);
  const generateTooltipText = ([{ name, value }]) => `
    ${name}<br/>
    ${t('QUESTIONNAIRE.ANSWER_WITH_COUNT', { count: value })}<br/>
    ${t('COMMON.INTL_PERCENT', { value: total ? value / total : 0 })}`;

  const options = {
    grid: {
      left: 120,
    },
    backgroundColor: 'white',
    yAxis: {
      type: 'category',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#102131',
        fontFamily: 'Poppins, sans-serif',
        fontSize: 12,
        fontWeight: 'bold',
      },
      data: answers.map(el => (el.name.length > 16 ? `${el.name.slice(0, 13)}...` : el.name)),
    },
    xAxis: {
      type: 'value',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#102131',
        fontFamily: 'Poppins, sans-serif',
        fontSize: 12,
        fontWeight: 'bold',
      },
      splitLine: {
        show: false,
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      position: 'top',
      backgroundColor: 'rgba(50, 50, 50, 0.7)',
      formatter: generateTooltipText,
      textStyle: {
        color: 'white',
        fontFamily: 'Poppins, sans-serif',
        fontSize: 24,
        fontWeight: 600,
        textAlign: 'center',
        align: 'center',
      },
      confine: true,
    },
    series: {
      type: 'bar',
      barWidth: '80%',
      data: answers,
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          1, 0, 0, 0,
          [{ offset: 0, color: '#6F5AEE' }, { offset: 1, color: '#A77FFF' }],
        ),
      },
      emphasis: {
        itemStyle: {
          color: new echarts.graphic.LinearGradient(
            1, 0, 0, 0,
            [{ offset: 0, color: '#9E82ED' }, { offset: 1, color: '#EB8DCD' }],
          ),
        },
      },
    },
  };

  const questions = data.map(({ question }, idx) => ({ value: idx.toString(), label: question }));

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <Select
          id="multiple-choice"
          value={questions.length ? selectedQuestion : null}
          setFieldValue={(_, value) => setSelectedQuestion(value)}
          options={questions}
          iconName="name"
        />
      </div>
      <ReactEcharts
        option={options}
        notMerge
        style={{
          width: '100%',
          height: '100%',
          paddingLeft: '10px'
        }}
      />
    </div>
  );
};

QuestionBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })).isRequired,
  })).isRequired,
};

export default QuestionBarChart;
